import _mixin from '../_mixin'

export default {
  name: 'SVersionJoin',
  cnName: '加入按钮类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: 'LG4LKO7NPTR3LPWGGPN4AFCOOY',
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/69dc3d21932729a7150639b8bf68911a.jpg',
      style: {
        width: '1920px',
        height: '1058px'
      }
    },
    btnJoin: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/799bc1238c39ac02df83ec370b8b1e8e.png',
      style: {
        width: '165px',
        height: '50px',
        position: 'absolute',
        top: '390px',
        right: '',
        bottom: '',
        left: '1018px'
      }
    }
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnJoin',
      label: '加入按钮图片',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
